import React, { useState, useCallback, useEffect } from 'react';
import SalesActionStat from '../../components/salesActionStat/SalesActionStat';
import { useSnackbar } from 'notistack'; 
import { getActionStat, getDepartmentAndUserList, getActionStatList } from '../../lib/api/salesAction';
import { getHolidayList } from '../../lib/api/holidayAction';

const SalesActionStatContainer = ({ toggleCalFull, isCalFull }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [statEvents, setStatEvents] = useState([]);
    const [actionEvents, setActionEvents] = useState([]);
    const [holidayList, setHolidayList] = useState([]);
    const [selectedDate, setSelectedDate] = useState(new Date());

    const [dptUuid, setDptUuid] = useState('');
    const [usrUuid, setUsrUuid] = useState('');
    
    const [dptList, setDptList] = useState([]);
    const [usrList, setUsrList] = useState([]);

    const handleFetchStat = useCallback(async (startDate, endDate, targetDptUuid, targetUsrUuid, targetLoginUuid) => {
        if (!startDate || !endDate) return;

        const currentDptUuid = targetDptUuid !== undefined ? targetDptUuid : dptUuid;
        const currentUsrUuid = targetUsrUuid !== undefined ? targetUsrUuid : usrUuid;
        
        let currentLoginUuid = targetLoginUuid;
        if (currentLoginUuid === undefined && !currentDptUuid && !currentUsrUuid) {
            const localUser = localStorage.getItem('user');
            if (localUser) {
                const parsedUser = JSON.parse(localUser);
                currentLoginUuid = parsedUser.usrUuid || parsedUser.userUuid || '';
            }
        }
        
        try {
            const [statResponse, listResponse] = await Promise.all([
                getActionStat(currentDptUuid, currentUsrUuid, startDate, endDate, currentLoginUuid),
                getActionStatList(currentDptUuid, currentUsrUuid, startDate, endDate, currentLoginUuid)
            ]);

            const statData = statResponse?.data?.list || [];
            const listData = listResponse?.data?.list || [];

            setStatEvents(statData);
            setActionEvents(listData);
        } catch (err) {
            console.error('영업활동 통계 및 목록 로드 오류:', err);
            const message = err.response?.data?.message || err.message || '데이터를 불러오는 중 오류가 발생했습니다.';
            enqueueSnackbar(message, { variant: 'error' });
        }
    }, [dptUuid, usrUuid, enqueueSnackbar]);

    const fetchInitialMasterData = useCallback(async () => {
        try {
            if (typeof getDepartmentAndUserList !== 'function') return;

            const localUser = localStorage.getItem('user');
            let loginUsrUuid = '';
            if (localUser) {
                const parsedUser = JSON.parse(localUser);
                loginUsrUuid = parsedUser.usrUuid || parsedUser.userUuid || '';
            }

            const currentYear = new Date().getFullYear();

            const [response, holidayResponse] = await Promise.all([
                getDepartmentAndUserList(loginUsrUuid),
                getHolidayList(currentYear)
            ]);
            
            const fetchedDptList = response?.data?.dptList || [];
            const fetchedUsrList = response?.data?.usrList || [];
            const fetchedHolidayList = holidayResponse?.data?.data || [];

            setDptList(fetchedDptList);
            setUsrList(fetchedUsrList);
            setHolidayList(fetchedHolidayList);

        } catch (err) {
            console.error('초기 조직도 마스터 데이터 로드 오류:', err);
            enqueueSnackbar('기본 정보 및 휴일 데이터를 불러오는 중 오류가 발생했습니다.', { variant: 'error' });
        }
    }, [enqueueSnackbar]);

    useEffect(() => {
        fetchInitialMasterData();
    }, [fetchInitialMasterData]);

    return (
        <SalesActionStat 
            statEvents={statEvents}
            actionEvents={actionEvents}
            holidayList={holidayList}
            selectedDate={selectedDate}
            setSelectedDate={setSelectedDate}
            dptUuid={dptUuid}
            setDptUuid={setDptUuid}
            usrUuid={usrUuid}
            setUsrUuid={setUsrUuid}
            dptList={dptList}
            usrList={usrList}
            onFetchStat={handleFetchStat} 
        />
    );
};

export default SalesActionStatContainer;
